// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"623":"e1b91267","686":"49a731e3","911":"3a12f205"}[chunkId] + ".chunk.js";
};